import { useState } from 'react';
const useCustomHook = () => {
  const [captchaId, setCaptchaId] = useState(null);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [saveNumber, setSaveNumber] = useState(false);
  const [isDisable, setDisable] = useState({
    isPayaDisable: false,
    isCardDisable: false,
    isSatnaDisable: true,
  });
  const [list, setList] = useState({ card: [], sheba: [] });
  const [cardInfoAcc, setCardInfoAcc] = useState('SETTLEMENT_TOOL_PAYA');
  const [isShow, setIsShow] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [role, setRole] = useState();
  const [itemNeed, setItemNeed] = useState([]);
  const [blockedAccounts, setBlockedAccounts] = useState([]);
  const [inquiryAccount, setInquiryAccount] = useState('');
  const [limitPrice, setLimitPrice] = useState([]);
  const [isShowLoadingSeach, setIsShowLoadingSeach] = useState(false);
  const [searchText, setSearchText] = useState('');

  return {
    captchaId,
    setCaptchaId,
    enteredCaptcha,
    setEnteredCaptcha,
    saveNumber,
    setSaveNumber,
    isDisable,
    setDisable,
    list,
    setList,
    cardInfoAcc,
    setCardInfoAcc,
    isShow,
    setIsShow,
    openDialog,
    setOpenDialog,
    selectedValue,
    setSelectedValue,
    isLoading,
    setIsLoading,
    openBackDrop,
    setOpenBackDrop,
    role,
    setRole,
    itemNeed,
    setItemNeed,
    blockedAccounts,
    setBlockedAccounts,
    inquiryAccount,
    setInquiryAccount,
    isShowLoadingSeach,
    setIsShowLoadingSeach,
    searchText,
    setSearchText,
    limitPrice,
    setLimitPrice,
  };
};

export default useCustomHook;
